var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "md:grid md:grid-cols-3 md:gap-6" },
    [
      _c("jet-section-title", {
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [_vm._t("title")]
              },
              proxy: true,
            },
            {
              key: "description",
              fn: function () {
                return [_vm._t("description")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mt-5 md:mt-0 md:col-span-2" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.$emit("submitted")
              },
            },
          },
          [
            _c("div", { staticClass: "shadow overflow-hidden sm:rounded-md" }, [
              _c("div", { staticClass: "px-4 py-5 bg-white sm:p-6" }, [
                _c(
                  "div",
                  { staticClass: "grid grid-cols-6 gap-6" },
                  [_vm._t("form")],
                  2
                ),
              ]),
              _vm._v(" "),
              _vm.hasActions
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6",
                    },
                    [_vm._t("actions")],
                    2
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }